import { render, staticRenderFns } from "./fileAgentWidget.vue?vue&type=template&id=25433836&scoped=true&"
import script from "./fileAgentWidget.vue?vue&type=script&lang=ts&"
export * from "./fileAgentWidget.vue?vue&type=script&lang=ts&"
import style0 from "vue-file-agent/dist/vue-file-agent.css?vue&type=style&index=0&lang=css&"
import style1 from "./fileAgentWidget.vue?vue&type=style&index=1&id=25433836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25433836",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBadge,VCard,VCardActions,VCardSubtitle,VCheckbox,VDialog,VRow,VSwitch})
